import CommonStyleEditor from "./CommonStyleEditor";
import { useState } from "react";
import { FormFieldsQueries } from "../../../../../../requests/queries/FormFieldsQueries";
import ColorPicker from "../picker/ColorPicker";

export default function FormCellProperties({ cell, onChange }) {

    const [newEntry, setNewEntry] = useState(null);
    const [newEntryName, setNewEntryName] = useState(null);
    const [newEntryOptions, setNewEntryOptions] = useState(null);

    const addFormField = async () => {
        try {
            const formField = await FormFieldsQueries.createFormField(cell.id, newEntryName, newEntry);
            setNewEntry(null);
            setNewEntryName(null);
            onChange(cell.cell_id, {fields: [...cell.fields, formField]});
        } catch (error) {
            console.error("Erreur lors de l'ajout de l'entrée:", error);
        }
    }

    const cell_type = cell.type;

    return (
        <div className="property-section">
            <div className="property-section-title">Formulaire</div>
            <div className="property-row">
                <div className="property-label">Nouvel entrée</div>
                <select className="property-input property-input-small" value={newEntry || ''} onChange={(e) => setNewEntry(e.target.value)}>
                    <option value="">None</option>
                    <option value="text">Texte</option>
                    <option value="number">Nombre</option>
                    <option value="email">Email</option>
                    <option value="password">Mot de passe</option>
                    <option value="tel">Téléphone</option>
                    <option value="textarea">Textearea</option>
                    <option value="select">Select</option>
                    <option value="checkbox">Checkbox</option>
                    <option value="radio">Radio</option>
                    <option value="date">Date</option>
                    <option value="time">Heure</option>
                    <option value="datetime-local">Date et heure</option>
                    <option value="url">URL</option>
                    <option value="search">Recherche</option>
                    <option value="color">Couleur</option>
                    <option value="range">Range</option>
                    <option value="tel">Téléphone</option>
                    <option value="tel">Téléphone</option>
                </select>
            </div>
            {
                newEntry && (
                    <div className="property-row">
                        <div className="property-label">Nom de l'entrée</div>
                        <input className="property-input property-input-small" value={newEntryName || ''} onChange={(e) => setNewEntryName(e.target.value)}/>
                    </div>
                )
            }
            {
                newEntryName && (
                    <div className="property-row">
                        <div className="property-label">Ajouter</div>
                        <button className="property-button-add" onClick={() => addFormField()}>+</button>
                    </div>
                )
            }
            <CommonStyleEditor cell={cell} onChange={onChange}/>

            <div className="property-row">
                <div className="property-label">Couleur des textes</div>
                <ColorPicker value={cell.styles_properties?.text_color || '#000000'} onChange={(color) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, text_color: color}, type: cell_type})}/>
            </div>

            <div className="property-section-title">Style des champs</div>
            <div className="property-row">
                <div className="property-label">Couleur de fond</div>
                <ColorPicker value={cell.styles_properties?.background_color || '#ffffff'} onChange={(color) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, background_color: color}, type: cell_type})}/>
            </div>
        </div>
    )
}